<template>
    <btn v-if="data.is_locked" icon="fas fa-arrow-right" cssClass="btn btn-sm btn-primary" :click="() => $emit('locked', false)"></btn>
    <btn v-else icon="fas fa-pencil" cssClass="btn btn-sm btn-success" :click="() => $emit('locked', true)"></btn>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>